<div class="header-pages" [style.background-image]="'url(../../../assets/img/' + bgImage + ')'">
    <div [style.background-color]="bgColor" class="color-header">
    </div>
    <h1 *ngIf="title" class="mb-4 mb-md-0">{{ title }}</h1>
    <p *ngIf="description">{{ description }}</p>
</div>
<div class="angled_container"></div>